import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter, RouteComponentProps } from 'react-router';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { AlertsActions } from '../../store';
import { SearchBar } from '../SearchBar';
import { AlertListType, AlertType } from '../../store/alerts/types';
import { Spinner } from '../Spinner';
import { NavigationParamsType, SelectedBuilding } from '../../store/building/types';
import { AlertRow } from './components/AlertRow/AlertRow';
import { Notification } from '../Notification';
import './AlertList.css';
import { Pagination } from '../Pagination';

export interface Props {
  isLoading: boolean;
  allAlerts: AlertListType;
  selectedBuilding: SelectedBuilding;
  navigationParams: NavigationParamsType;
  loadAllAlerts(identifier: string, pageSize?: string, pageNumber?: string): void;
}

export declare type ComposedProps = Props & RouteComponentProps;

export interface State {
  selectedAlerts: string[];
  currentPage: number;
  filters: {};
  filteredAlertsList: AlertType[];
}

const alertsPerPage = window.innerWidth > 599 ? '20' : '5';

export class AlertList extends Component<ComposedProps, State> {
  state = {
    selectedAlerts: [] as string[],
    currentPage: 1,
    filters: { sortValue: 'TIME', isReversed: false, searchValue: '' },
    filteredAlertsList: [],
  };

  componentDidMount() {
    const {
      loadAllAlerts,
      selectedBuilding: { identifier },
    } = this.props;

    loadAllAlerts(identifier, alertsPerPage, '1');
  }

  updateSearchValue = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.persist();
    this.setState(
      (state) => ({
        ...state,
        filters: {
          ...state.filters,
          searchValue: e.target.value,
        },
      }),
      () => this.updateFilteredAlertsList(),
    );
  };

  updateFilteredAlertsList = () => {
    const { filters, filteredAlertsList } = this.state;
    const { allAlerts } = this.props;
    let tempAlertsList = filteredAlertsList.length > 0 ? filteredAlertsList : allAlerts.results;

    const filterList = { ...filters };

    if (filters.searchValue) {
      tempAlertsList = tempAlertsList.filter((alert) =>
        alert.name.replace(/\s/g, '').toLowerCase().includes(filters.searchValue.replace(/\s/g, '').toLowerCase()),
      );
    } else {
      tempAlertsList = allAlerts.results;
    }

    this.setState((state) => ({
      ...state,
      filters: filterList,
      filteredAlertsList: tempAlertsList,
    }));
  };

  changePage = (num: number) => {
    const {
      loadAllAlerts,
      selectedBuilding: { identifier },
    } = this.props;

    this.setState(
      (state) => ({
        ...state,
        currentPage: num,
      }),
      () => loadAllAlerts(identifier, alertsPerPage, num.toString()),
    );
  };

  renderAlerts() {
    const {
      allAlerts: { results: alertList },
    } = this.props;

    const { filteredAlertsList } = this.state;

    // initially the filteredRegisterList is empty
    const alertsList = filteredAlertsList.length === 0 ? alertList : filteredAlertsList;

    // logic for displaying incidents
    // const incidentsPerPage = window.innerWidth > 599 ? 10 : 5;

    if (alertsList.length === 0) {
      return (
        <div className="alert-admin__no-alerts-message">
          <Notification message="There are currently no incidents for this building." type="success" />
        </div>
      );
    }

    return (
      <div>
        {alertsList.map((alert) => {
          const { name, uid_hash } = alert;

          return (
            <label htmlFor={name} key={name}>
              <AlertRow key={uid_hash} alert={alert} openEdit={() => this.onOpenEdit(uid_hash)} />
            </label>
          );
        })}
      </div>
    );
  }

  onOpenEdit(alertId: string) {
    const {
      selectedBuilding: { identifier },
    } = this.props;
    this.props.history.push(`/${identifier}/alerts/alert-setup?id=${alertId}`);
  }

  render() {
    const { isLoading, allAlerts } = this.props;
    const {
      filters: { sortValue, isReversed, searchValue },
    } = this.state;

    return (
      <div className="alert-list">
        <ToastContainer />
        <div className="alert-list__header">
          <div className="alert-list__title">Alerts</div>
          <SearchBar
            value={searchValue}
            placeholderText="Search for a specific alert"
            onChange={(e) => this.updateSearchValue(e)}
          />
        </div>

        <div className="alert-list__column-names">
          <span className="alert-list__column-name-text">NAME</span>
          <span className="alert-list__column-name-text">SEVERITY LEVEL</span>
          <span className="alert-list__column-name-text">IS ACTIVE</span>
          {/* <span className="alert-list__column-name-text">EDIT</span> */}
        </div>
        {isLoading || !allAlerts.results ? (
          <div className="alert-list-loader">
            <Spinner />
          </div>
        ) : (
          this.renderAlerts()
        )}
        <Pagination
          currentPage={this.state.currentPage}
          itemsPerPage={parseInt(alertsPerPage)}
          numberOfItems={allAlerts.count}
          onClick={this.changePage}
        />
      </div>
    );
  }
}

export function mapStateToProps(state: any) {
  return {
    allAlerts: state.alertsReducer.allAlerts,
    isLoading: state.alertsReducer.isLoading,
    selectedBuilding: state.buildingReducer.selectedBuilding,
    navigationParams: state.buildingReducer.navigationParams,
  };
}

const mapDispatchToProps = {
  loadAllAlerts: AlertsActions.loadAllAlertsV2,
};

const AlertListWithRouter = withRouter<ComposedProps>(AlertList);
export const ConnectedAlertListWithRouter = connect(mapStateToProps, mapDispatchToProps)(AlertListWithRouter);
